import Vue from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import router from './router';
import Toasted from 'vue-toasted';
import numeral from 'numeral';
import { format } from 'date-fns';
import { store } from './store/index';
import VueYouTubeEmbed from 'vue-youtube-embed';

Vue.config.productionTip = false;
Vue.use(Toasted, {
  duration: 3000,
  position: 'top-right',
  theme: "bubble",
});

Vue.filter('currency', function (value) {
  if (typeof value !== "number") {
    return value;
  }
  let formatter = new Intl.NumberFormat('es-MX', {
    style: 'currency',
    currency: 'MXN'
  });
  return formatter.format(value);
});

Vue.filter("number", function (value) {
  return numeral(value).format("0.00");
});

Vue.filter('date', function (value) {
  if (value == null) {
    return "---";
  }
  if (value) {
    return format(new Date(value), "dd-MMM-yyyy");
  }
});

Vue.filter('uppercase', function (value) {
  if (value == null) {
    return "---";
  }

  return value.toUpperCase()
})
Vue.filter('noUnderscore', function (value) {
  if (value == null) {
    return "---";
  }

  return value.replace(/_/g, ' ');
})

Vue.use(VueYouTubeEmbed, { global: true });

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
